import SearchHistory from '@/components/Search/SearchHistory'
import { SearchHistoryItem } from '@/hooks/useSearchHistory'
import { LanguageRecord } from '@/graphql/types'
import { cn } from '@desoutter/uikit'

export default function InitView({
	text,
	searchHistory,
	onSearchClick,
	translations,
	isModal,
}: {
	text: string
	searchHistory: SearchHistoryItem[]
	onSearchClick: (query: string) => void
	translations?: Partial<LanguageRecord>
	isModal?: boolean
}) {
	return (
		<div
			className={cn(
				'flex flex-col items-center justify-center gap-12 my-8 w-full lg:w-[1024px] flex-shrink',
				{
					'lg:w-full': isModal,
				},
			)}
		>
			<div className="flex items-center justify-center gap-3">
				<svg
					width="51"
					height="50"
					viewBox="0 0 51 50"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M35.917 5.0625H15.0837C8.83366 5.0625 4.66699 9.22917 4.66699 15.4792V27.9792C4.66699 34.2292 8.83366 38.3958 15.0837 38.3958V42.8333C15.0837 44.5 16.9378 45.5 18.3128 44.5625L27.5837 38.3958H35.917C42.167 38.3958 46.3337 34.2292 46.3337 27.9792V15.4792C46.3337 9.22917 42.167 5.0625 35.917 5.0625ZM25.5003 30.4167C24.6253 30.4167 23.9378 29.7083 23.9378 28.8542C23.9378 28 24.6253 27.2917 25.5003 27.2917C26.3753 27.2917 27.0628 28 27.0628 28.8542C27.0628 29.7083 26.3753 30.4167 25.5003 30.4167ZM28.1253 21.7708C27.3128 22.3125 27.0628 22.6667 27.0628 23.25V23.6875C27.0628 24.5417 26.3545 25.25 25.5003 25.25C24.6462 25.25 23.9378 24.5417 23.9378 23.6875V23.25C23.9378 20.8333 25.7087 19.6458 26.3753 19.1875C27.1462 18.6667 27.3962 18.3125 27.3962 17.7708C27.3962 16.7292 26.542 15.875 25.5003 15.875C24.4587 15.875 23.6045 16.7292 23.6045 17.7708C23.6045 18.625 22.8962 19.3333 22.042 19.3333C21.1878 19.3333 20.4795 18.625 20.4795 17.7708C20.4795 15 22.7295 12.75 25.5003 12.75C28.2712 12.75 30.5212 15 30.5212 17.7708C30.5212 20.1458 28.7712 21.3333 28.1253 21.7708Z"
						fill="#868687"
					/>
				</svg>
				<p className="max-w-64 text-xs text-gray-300">{text}</p>
			</div>

			<SearchHistory
				searchHistory={searchHistory}
				onSearchClick={onSearchClick}
				translations={translations}
				isModal={isModal}
			/>
		</div>
	)
}
